import { AxiosClient } from './httpClient';

export default class WidgetAPI {
  static getRegionDonation(code: string) {
    return AxiosClient.get(`/statistics/v1/regions/?identifiers=${code}`);
  }

  static getCampaignDonation(code: string) {
    return AxiosClient.get(`/statistics/v1/campaigns/?identifiers=${code}`);
  }

  static getPartnerDonation(code: any) {
    return AxiosClient.get(`/statistics/v1/partners/?identifiers=${code}`);
  }
}
